import { render, staticRenderFns } from "./engagementsFilesTabNew.vue?vue&type=template&id=c04c052e&scoped=true&"
import script from "./engagementsFilesTabNew.vue?vue&type=script&lang=js&"
export * from "./engagementsFilesTabNew.vue?vue&type=script&lang=js&"
import style0 from "./engagementsFilesTabNew.vue?vue&type=style&index=0&id=c04c052e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04c052e",
  null
  
)

export default component.exports